(function () {
  'use strict';

  function getKlaviyoCompanyId() {
    var scripts = document.querySelectorAll('script[src*="klaviyo"]');
    for (var i = 0; i < scripts.length; i++) {
      var src = scripts[i].src;
      var pathMatch = src.match(/\/js\/([A-Za-z0-9]{6})\//);
      if (pathMatch) return pathMatch[1];
      var queryMatch = src.match(/company_id=([A-Za-z0-9]{6})/);
      if (queryMatch) return queryMatch[1];
    }
    if (window.klaviyo && window.klaviyo.companyId) return window.klaviyo.companyId;
    console.error('Strava TT Registration: Could not detect Klaviyo company ID');
    return null;
  }

  function regKey(city, date) {
    return ('stt_reg_' + city + '_' + date).toLowerCase().replace(/[^a-z0-9]/g, '_');
  }

  function markAsRegistered(card) {
    card.classList.add('stt-registered');
  }

  function isValidEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  }

  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function trapFocus(e) {
    var modal = document.querySelector('.stt-modal');
    if (!modal) return;
    var focusable = modal.querySelectorAll(FOCUSABLE);
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.key === 'Tab') {
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
  }

  function escHtml(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function init() {
    var overlay = document.getElementById('stt-modal-overlay');
    if (!overlay) return;
    if (overlay.dataset.sttInit) return;
    overlay.dataset.sttInit = 'true';

    var config = {
      companyId: overlay.dataset.companyId || getKlaviyoCompanyId(),
      listId: overlay.dataset.listId,
      waiverVersion: overlay.dataset.waiverVersion
    };

    var currentCard = null;
    var currentRide = {};

    var formView      = document.getElementById('stt-form-view');
    var successView   = document.getElementById('stt-success');
    var cityEl        = document.getElementById('stt-modal-city');
    var dateEl        = document.getElementById('stt-modal-date');
    var detailsEl     = document.getElementById('stt-modal-details');
    var form          = document.getElementById('stt-reg-form');
    var errorEl       = document.getElementById('stt-form-error');
    var firstNameIn   = document.getElementById('stt-first-name');
    var lastNameIn    = document.getElementById('stt-last-name');
    var emailIn       = document.getElementById('stt-email');
    var waiverCheck   = document.getElementById('stt-waiver-check');
    var submitBtn     = document.getElementById('stt-submit-btn');
    var btnText       = submitBtn.querySelector('.stt-btn-text');
    var btnLoading    = submitBtn.querySelector('.stt-btn-loading');
    var successMsg    = document.getElementById('stt-success-msg');
    var doneBtn       = overlay.querySelector('.stt-success-done');
    var closeBtn      = overlay.querySelector('.stt-modal__close');
    var bannerWrap    = document.getElementById('stt-modal-banner');
    var bannerImg     = document.getElementById('stt-modal-banner-img');

    function openModal(cardEl) {
      currentCard = cardEl;
      var d = cardEl.dataset;
      currentRide = {
        city:            d.city || '',
        date:            d.date || '',
        dateDisplay:     d.dateDisplay || '',
        meet:            d.meet || '',
        roll:            d.roll || '',
        distance:        d.distance || '',
        elev:            d.elev || '',
        finish:          d.finish || '',
        parkUp:          d.parkUp || '',
        rideMonth:       d.rideMonth || '',
        stravaRoute:     d.stravaRoute || '',
        leaderName:      d.leaderName || '',
        rideDescription: d.rideDescription || '',
        bannerUrl:       d.bannerUrl || ''
      };

      if (bannerWrap && bannerImg) {
        if (currentRide.bannerUrl) {
          bannerImg.src = currentRide.bannerUrl;
          bannerImg.alt = currentRide.city;
          bannerWrap.style.display = '';
        } else {
          bannerImg.removeAttribute('src');
          bannerWrap.style.display = 'none';
        }
      }

      var modalPanel = overlay.querySelector('.stt-modal');
      if (modalPanel && d.modalBg) modalPanel.style.background = d.modalBg;
      if (modalPanel) modalPanel.style.color = d.modalText || '';
      if (detailsEl && d.modalAccent) detailsEl.style.background = d.modalAccent;
      if (detailsEl) detailsEl.style.color = d.modalAccentText || '';

      cityEl.textContent = currentRide.bannerUrl ? '' : currentRide.city;
      cityEl.style.display = currentRide.bannerUrl ? 'none' : '';
      dateEl.textContent = currentRide.dateDisplay;

      var details = '';
      if (currentRide.meet)        details += '<p><strong>Meet:</strong> '     + escHtml(currentRide.meet)     + '</p>';
      if (currentRide.roll)        details += '<p><strong>Roll:</strong> '     + escHtml(currentRide.roll)     + '</p>';
      if (currentRide.distance)    details += '<p><strong>Distance:</strong> ' + escHtml(currentRide.distance) + '</p>';
      if (currentRide.elev)        details += '<p><strong>Elev:</strong> '     + escHtml(currentRide.elev)     + '</p>';
      if (currentRide.finish)      details += '<p><strong>Finish:</strong> '   + escHtml(currentRide.finish)   + '</p>';
      if (currentRide.parkUp)      details += '<p><strong>Park Up:</strong> '  + escHtml(currentRide.parkUp)   + '</p>';
      if (currentRide.stravaRoute) {
        var routeLabel = currentRide.stravaRoute.indexOf('strava.com') >= 0
          ? 'View Strava Route' : (currentRide.stravaRoute.indexOf('grouprides.cc') >= 0 ? 'View on GroupRides' : 'View Route');
        details += '<p><strong>Route:</strong> <a href="' + escHtml(currentRide.stravaRoute) + '" target="_blank" rel="noopener noreferrer" style="color:inherit;text-decoration:underline;">' + routeLabel + ' &rarr;</a></p>';
      }
      if (currentRide.rideDescription) details += '<p>' + escHtml(currentRide.rideDescription) + '</p>';
      detailsEl.innerHTML = details;
      detailsEl.style.display = details ? '' : 'none';

      form.reset();
      if (waiverCheck) waiverCheck.checked = false;
      submitBtn.disabled = true;
      errorEl.style.display = 'none';
      errorEl.textContent = '';
      btnText.style.display = '';
      btnLoading.style.display = 'none';
      formView.style.display = '';
      successView.style.display = 'none';

      overlay.style.display = '';
      requestAnimationFrame(function () { overlay.classList.add('stt-modal--open'); });
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', trapFocus);
      firstNameIn.focus();
    }

    function closeModal() {
      overlay.classList.remove('stt-modal--open');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', trapFocus);
      setTimeout(function () { overlay.style.display = 'none'; }, 300);
    }

    closeBtn.addEventListener('click', closeModal);
    doneBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.style.display !== 'none') closeModal();
    });

    function validateForm() {
      var valid =
        firstNameIn.value.trim().length > 0 &&
        isValidEmail(emailIn.value.trim()) &&
        (!waiverCheck || waiverCheck.checked);
      submitBtn.disabled = !valid;
    }

    firstNameIn.addEventListener('input', validateForm);
    emailIn.addEventListener('input', validateForm);
    if (waiverCheck) waiverCheck.addEventListener('change', validateForm);

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var firstName = firstNameIn.value.trim();
      var lastName = lastNameIn.value.trim();
      var email = emailIn.value.trim();

      if (!firstName) { showError('Please enter your first name.'); return; }
      if (!isValidEmail(email)) { showError('Please enter a valid email address.'); return; }
      if (waiverCheck && !waiverCheck.checked) { showError('Please accept the ride waiver to continue.'); return; }
      if (!config.companyId) { showError('Registration is temporarily unavailable. Please try again later.'); return; }

      submitBtn.disabled = true;
      btnText.style.display = 'none';
      btnLoading.style.display = '';
      errorEl.style.display = 'none';

      var headers = { 'Content-Type': 'application/json', 'revision': '2026-07-15' };
      var ride = currentRide;
      var baseUrl = 'https://a.klaviyo.com/client/';

      var profileAttrs = {
        email: email,
        first_name: firstName,
        last_name: lastName,
        properties: {
          last_strava_tt_city: ride.city,
          last_strava_tt_date: ride.date
        }
      };
      if (waiverCheck) {
        profileAttrs.properties.waiver_accepted = true;
        profileAttrs.properties.waiver_accepted_date = new Date().toISOString();
        profileAttrs.properties.waiver_version = config.waiverVersion;
      }

      var subscribeBody = JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Strava Time Attack Registration',
            profile: { data: { type: 'profile', attributes: profileAttrs } }
          },
          relationships: {
            list: { data: { type: 'list', id: config.listId } }
          }
        }
      });

      var eventBody = JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            metric: { data: { type: 'metric', attributes: { name: 'Registered for Strava Time Attack' } } },
            profile: { data: { type: 'profile', attributes: profileAttrs } },
            unique_id: (email + '_' + ride.city + '_' + ride.date).toLowerCase().replace(/[^a-z0-9]/g, '_'),
            properties: {
              ride_city:        ride.city,
              ride_date:        ride.date,
              date_display:     ride.dateDisplay,
              meet:             ride.meet,
              roll:             ride.roll,
              distance:         ride.distance,
              elev:             ride.elev,
              finish:           ride.finish,
              park_up:          ride.parkUp,
              ride_month:       ride.rideMonth,
              strava_route:     ride.stravaRoute,
              ride_leader_name: ride.leaderName,
              ride_description: ride.rideDescription
            }
          }
        }
      });

      var profileBody = JSON.stringify({
        data: { type: 'profile', attributes: profileAttrs }
      });

      var callNames = ['subscribe', 'event', 'profile'];
      console.log('[StravaTT] Sending registration — company:', config.companyId, 'list:', config.listId, 'email:', email);

      Promise.all([
        fetch(baseUrl + 'subscriptions/?company_id=' + config.companyId, { method: 'POST', headers: headers, body: subscribeBody }),
        fetch(baseUrl + 'events/?company_id='        + config.companyId, { method: 'POST', headers: headers, body: eventBody }),
        fetch(baseUrl + 'profiles/?company_id='      + config.companyId, { method: 'POST', headers: headers, body: profileBody })
      ])
        .then(function (responses) {
          responses.forEach(function (r, i) {
            var ok = r.ok || r.status === 202;
            console.log('[StravaTT]', callNames[i], '→', r.status, ok ? '✓' : '✗');
            if (!ok) r.text().then(function (body) { console.error('[StravaTT]', callNames[i], 'error body:', body); });
          });
          var subOk = responses[0].ok || responses[0].status === 202;
          if (subOk) {
            onSuccess(ride);
          } else {
            showError('Registration failed. Please check your email and try again.');
            submitBtn.disabled = false;
            btnText.style.display = '';
            btnLoading.style.display = 'none';
          }
        })
        .catch(function (err) {
          console.error('[StravaTT] Network error:', err);
          showError('Registration failed. Please check your connection and try again.');
          submitBtn.disabled = false;
          btnText.style.display = '';
          btnLoading.style.display = 'none';
        });
    });

    function onSuccess(ride) {
      localStorage.setItem(regKey(ride.city, ride.date), 'true');
      if (currentCard) markAsRegistered(currentCard);
      successMsg.textContent = "You're registered for the " + ride.city + ' Time Attack' + (ride.dateDisplay ? ' on ' + ride.dateDisplay : '') + '. Good luck.';
      formView.style.display = 'none';
      successView.style.display = '';
    }

    function showError(msg) {
      errorEl.textContent = msg;
      errorEl.style.display = '';
    }

    /* Register buttons */
    document.querySelectorAll('.strava-tt__card .strava-tt__btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openModal(btn.closest('.strava-tt__card'));
      });
    });

    /* Restore registered state */
    document.querySelectorAll('.strava-tt__card').forEach(function (card) {
      var key = regKey(card.dataset.city, card.dataset.date);
      if (localStorage.getItem(key)) markAsRegistered(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
